<template lang="pug">
.c-section-banner.hero.is-info.is-bold
  .hero-body
    .container
      h1.title
        slot
</template>

<script>
export default {
  name: "SectionBanner"
};
</script>
